export default "__VITE_ASSET__DOZLu8PR__"